const CustomScrollLink = ({ toId, className, onClick, children, isActive }) => {
    
    const handleClick = (e) => {
        e.preventDefault();
        
        const targetElement = document.getElementById(toId);

        if (targetElement) {
            targetElement.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        } else {
            console.error(`Component with following ID not found: ${toId}`);
        }

        if (onClick) {
            onClick();
        }
    };

    const baseClasses = "px-3 py-2 rounded-md text-sm transition-colors duration-300 whitespace-nowrap";

    const activeClasses = isActive 
        ? 'text-[#1B5125] font-extrabold'
        : 'text-gray-700 hover:bg-gray-100 hover:text-[#1B5125] font-medium';

    const finalClasses = `${baseClasses} ${activeClasses} ${className || ''}`;

    return (
        <a
            href={`#${toId}`}
            className={finalClasses} 
            onClick={handleClick}
        >
            {children}
        </a>
    );
};

export default CustomScrollLink;
